import React, { useState, useEffect, useContext } from "react";
import { createPartnerKeys } from "../../Utils/partnerKeys";
import { useLocation, useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import SHA from "sha.js";
import { useAuth } from "../../Context/AuthContext";
import {
  decryptText,
  encryptText,
  pbdkf2,
} from "../../Utils/OstreonEncryption";
import styles from "./styles/Register.module.css";
import config from "../../config";
import PasswordRequirements from "../Password Requirements/PasswordRequirements";
import { validatePasswordStrength } from "../../Utils/passwordRequirements";

import {
  checkNewPasswordValidity,
  partnerUpdateAuth,
  verifyStartPermission,
} from "../../Utils/partnerUtils";
import { useCompactItemContext } from "antd/es/space/Compact";
import { LanguageContext } from "../../Context/changeLanguageProvider";

function PartnerLogin() {
  const location = useLocation()
  const navigate = useNavigate();
  if (!location?.state?.token) navigate('/logout', {replace:true})
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const auth = useAuth();

  const private_key = sessionStorage.getItem("ostreon_key");

  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  //Cheking if the user can stay here
  // useEffect(() => {
  //   verifyStartPermission()
  //     .then((res) => {
  //       if (res.status === 200) return;
  //       else navigate("/logout", { replace: true });
  //     })
  //     .catch((e) => {
  //       navigate("/logout", { replace: true });
  //     });
  // }, []);
  useEffect(() => {
    scrollToTop();
  }, []);

  const [checked, setChecked] = useState(false);
  const [error, setError] = useState({
    password: null,
    confirm_password: null,
    register_error: null,
  });
  const [data, setData] = useState({
    password: "",
    confirm_password: "",
  });
  const errorMessages = {
    password: dublicatedcontent?.please_enter_your_password,
    confirm_password: dublicatedcontent?.please_confirm_your_password,
  };
  const [pwdreq, setpwdreq] = useState();
  const [pwdreqconfirm, setpwdreqConfirm] = useState();
  const resetError = () => {
    Object.keys(error).forEach((key) => {
      setError((prevError) => ({ ...prevError, [key]: null }));
    });
  };
  const validateData = () => {
    resetError();
    if (validateForm()) {
      return true;
    }
    setTimeout(() => {
      resetError();
    }, 5000);
    return false;
  };
  const validateForm = () => {
    let passValidated = false,
      fieldsValidated = false,
      passMatchValidated = false;

    if (Object.keys(pwdreq).some((key) => pwdreq[key] === "")) {
      setError({ ...error, password: dublicatedcontent?.password_do_not_match_policy});
    } else {
      passValidated = true;
    }

    if (data["password"] !== data["confirm_password"]) {
      setError((prevError) => ({
        ...prevError,
        confirm_password: dublicatedcontent?.password_do_not_match,
      }));
    } else {
      passMatchValidated = true;
    }

    const emptyKeys = Object.keys(data)
      .filter((key) => data[key] === "")
      .map((key) => key);
    emptyKeys.forEach((key) => {
      if (data[key] === "") {
        setError((prevError) => ({ ...prevError, [key]: errorMessages[key] }));
      }
    });
    if (emptyKeys.length === 0) {
      fieldsValidated = true;
    }

    if (passValidated && fieldsValidated && passMatchValidated) {
      return true;
    }
  };

  const changeData = (value, field) => {
    setData((prevData) => ({ ...prevData, [field]: value }));
  };

  // password hide/show

  const [passwordVisibility, setPasswordVisibility] = useState({});

  const handleTogglePassword = (fieldName) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  const isPasswordVisible = (fieldName) => {
    return passwordVisibility[fieldName];
  };

  // password popups

  const [passwordIsFocused, setPasswordIsFocused] = useState(false);

  const handleMouseEnterPassword = () => {
    setPasswordIsFocused(true);
  };

  const handleMouseLeavePassword = () => {
    setPasswordIsFocused(false);
  };

  const [hideTimeout, setHideTimeout] = useState(null);

  const handlePasswordFocusIn = () => {
    clearTimeout(hideTimeout); // Clear any existing timeout
    setPasswordIsFocused(true);
    setConfirmPasswordIsFocused(false);
  };

  const handlePasswordFocusOut = () => {
    // Set a delay before hiding the div
    const timeout = setTimeout(() => {
      setPasswordIsFocused(false);
    }, 300); // Adjust the delay time (in milliseconds) as needed
    setHideTimeout(timeout);
  };

  // password confirm popups

  const [confirmPasswordIsFocused, setConfirmPasswordIsFocused] =
    useState(false);

  const handleMouseEnterConfirmPassword = () => {
    setConfirmPasswordIsFocused(true);
  };

  const handleMouseLeaveConfirmPassword = () => {
    setConfirmPasswordIsFocused(false);
  };

  const [hideConfirmTimeout, setHideConfirmTimeout] = useState(null);

  const handleConfirmPasswordFocusIn = () => {
    clearTimeout(hideConfirmTimeout); // Clear any existing timeout
    setConfirmPasswordIsFocused(true);
    setPasswordIsFocused(false);
  };

  const handleConfirmPasswordFocusOut = () => {
    // Set a delay before hiding the div
    const timeout = setTimeout(() => {
      setConfirmPasswordIsFocused(false);
    }, 300); // Adjust the delay time (in milliseconds) as needed
    setHideConfirmTimeout(timeout);
  };

  const generateKey = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let uid = "";
    for (let i = 0; i < 32; i++) {
      uid += chars[Math.floor(Math.random() * chars.length)];
    }
    return uid.replace(/(.{4})/g, "$1-").slice(0, -1);
  };

  const getAuth = async (password) => {
    const password_pbdkf2 = await pbdkf2(password, "OSTREON", 100000, 32 * 8);
    const recovery_key = generateKey();
    const recovery_key_pbdkf2 = await pbdkf2(
      recovery_key,
      "OSTREON",
      100000,
      32 * 8
    );
    const key = `${password}:${password}:${password}:OSTREON`;
    const private_key = SHA("sha256").update(key).digest("hex");
    const private_key_recovery_key = await encryptText(
      recovery_key,
      private_key
    );
    const recovery_key_private_key = await encryptText(
      private_key,
      recovery_key
    );
    return {
      private_key,
      // Needed to wrap the keypair a second way — see createPartnerKeys.
      recovery_key,
      password_pbdkf2: password_pbdkf2[0],
      recovery_key_pbdkf2: recovery_key_pbdkf2[0],
      private_key_recovery_key,
      recovery_key_private_key,
    };
  };

  useEffect(() => {
    //I´m invalidating this
    return
    setpwdreq(validatePasswordStrength(data.password, true));
    setpwdreqConfirm(validatePasswordStrength(data.confirm_password));
    const timer_id = setTimeout(async () => {
      pbdkf2(data.password, "OSTREON", 100000, 32 * 8)
        .then((password) => {
          return checkNewPasswordValidity(password[0]);
        })
        .then((res) => {
          if (res.status === 409) {
            setError({ ...error, password: dublicatedcontent?.use_a_new_password });
          } else {
            setError({});
          }
        });
    }, 1000);
    return () => clearTimeout(timer_id);
  }, [data.password]);

  const handleClick = async () => {
    if (!validateData()) {
      console.log("Data is not correct. Please check it");
      return;
    }
    if (Object.keys(pwdreq).some((key) => pwdreq[key] === "")) {
      setError({ ...error, register_error: dublicatedcontent?.password_do_not_match_policy });
      setTimeout(() => {
        setError({});
      }, 4000);
      return;
    }
    const {
      private_key,
      recovery_key,
      password_pbdkf2,
      recovery_key_pbdkf2,
      private_key_recovery_key,
      recovery_key_private_key,
    } = await getAuth(data.password);
    partnerUpdateAuth(
      password_pbdkf2,
      recovery_key_pbdkf2,
      private_key_recovery_key,
      recovery_key_private_key
    )
      .then((res) => {
        if (res.status === 200) {
          auth.login(true);
          auth.setOTP(true);
          console.log("Done");

          sessionStorage.setItem("ostreon_key", private_key);
          /*
            The one moment a partner's keypair can be created: they have just
            chosen a password Ostreon does not know, and been given a recovery
            code. Wrapping under both here is what makes a forgotten password
            survivable later.

            Not awaited and not fatal — a partner who cannot store a keypair can
            still use their account; sharing is simply unavailable until it
            succeeds.
          */
          createPartnerKeys(private_key, recovery_key).catch((err) =>
            console.log(err)
          );
          // navigate("/user/dashboard", { replace: true });
          navigate("/partner/prepare", { replace: true, state:{partner:true} });
        } else {
          throw new Error();
        }
      })
      .catch((e) => {
        console.log(e);
        setError({ ...error, register_error: dublicatedcontent?.an_error_occured_try_later });
      });
  };
  const checkPassRequirements = () => {
    setpwdreq(validatePasswordStrength(data.password, true));
  };
  const checkPassConfirmRequirements = () => {
    setpwdreq(validatePasswordStrength(data.password, true));
    setpwdreqConfirm(
      validatePasswordStrength(
        data.confirm_password,
        data["password"] === data["confirm_password"] &&
          data["confirm_password"] !== ""
      )
    );
  };
  useEffect(() => {
    checkPassRequirements();
  }, [data.password]);

  useEffect(() => {
    checkPassConfirmRequirements();
  }, [data.confirm_password]);

  return (
    <>
    {location?.state?.token?
    <div className={styles.background}>
      {/* <div className={styles.home_link} onClick={() => navigate("/")}>
        Back to Home Page
      </div> */}
      <div className={styles.title}>{dublicatedcontent?.partner_first_login}</div>
      <div className={styles.main}>
        <div className={styles.inputs}>
          <div className={styles.input_div}>
            <div className={styles.input_title}>
              {dublicatedcontent?.login_password}
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onMouseEnter={handleMouseEnterPassword}
                onMouseLeave={(e) => {
                  setTimeout(() => {
                    handleMouseLeavePassword();
                  }, 1500);
                }}
              >
                <path
                  d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961"
                  stroke="#26313D"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z"
                  stroke="#26313D"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.5975 10.7999H12.6035"
                  stroke="#26313D"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.89825 10.7999H9.90431"
                  stroke="#26313D"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.19707 10.7999H7.20314"
                  stroke="#26313D"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <input
              onClick={() =>
                setError({ ...error, password: null, confirm_password: null })
              }
              onChange={(e) => changeData(e.target.value, "password")}
              onFocus={() => handlePasswordFocusIn()}
              onBlur={(e) => {
                handlePasswordFocusOut();
              }}
              type={isPasswordVisible("passwordField1") ? "text" : "password"}
              name="passwordField1"
              className={
                error.password ? styles.input_error : styles.input_input
              }
            ></input>
            <div
              onClick={() => handleTogglePassword("passwordField1")}
              className={styles.password_button}
            >
              <svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                  fill="#B3B3B3"
                />
                <path
                  d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                  fill="#B3B3B3"
                />
              </svg>
            </div>
            {error.password ? (
              <div className={styles.error_div}>
                <div className={styles.error_logo}></div>
                <div>{error.password}</div>
              </div>
            ) : null}

            <div className={styles.password_popups}>
              {passwordIsFocused && <PasswordRequirements req={pwdreq} />}

              {passwordIsFocused && (
                <div className={styles.pass_hint}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961"
                      stroke="#26313D"
                      strokeWidth="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z"
                      stroke="#26313D"
                      strokeWidth="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5975 10.7999H12.6035"
                      stroke="#26313D"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.89825 10.7999H9.90431"
                      stroke="#26313D"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.19707 10.7999H7.20314"
                      stroke="#26313D"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className={styles.pass_hint_text}>
                    <div className={styles.strong}>
                      {dublicatedcontent?.password_is_never_sent_to_ostreon_servers}
                    </div>
                    {dublicatedcontent?.to_learn_mor_abour_security_please_read}{" "}
                    {parse(dublicatedcontent?.zero_trust_zero_knowledge_policy)}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.input_div}>
            <div className={styles.input_title}>
              {dublicatedcontent?.confirm_password}
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onMouseEnter={() => handleMouseEnterConfirmPassword()}
                onMouseLeave={(e) => {
                  setTimeout(() => {
                    handleMouseLeaveConfirmPassword();
                  }, 1500);
                }}
              >
                <path
                  d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961"
                  stroke="#26313D"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z"
                  stroke="#26313D"
                  strokeWidth="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.5975 10.7999H12.6035"
                  stroke="#26313D"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.89825 10.7999H9.90431"
                  stroke="#26313D"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.19707 10.7999H7.20314"
                  stroke="#26313D"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <input
              onClick={() =>
                setError({ ...error, password: null, confirm_password: null })
              }
              type={isPasswordVisible("passwordField2") ? "text" : "password"}
              name="passwordField2"
              onFocus={() => handleConfirmPasswordFocusIn()}
              onBlur={(e) => {
                handleConfirmPasswordFocusOut();
              }}
              onChange={(e) => changeData(e.target.value, "confirm_password")}
              className={
                error.confirm_password ? styles.input_error : styles.input_input
              }
            ></input>
            <div
              onClick={() => handleTogglePassword("passwordField2")}
              className={styles.password_button}
            >
              <svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                  fill="#B3B3B3"
                />
                <path
                  d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                  fill="#B3B3B3"
                />
              </svg>
            </div>
            {error.confirm_password ? (
              <div type="password" className={styles.error_div}>
                <div className={styles.error_logo}></div>
                <div>{error.confirm_password}</div>
              </div>
            ) : null}

            <div className={styles.password_confirm_popups}>
              {confirmPasswordIsFocused && (
                <PasswordRequirements req={pwdreqconfirm} />
              )}

              {confirmPasswordIsFocused && (
                <div className={styles.confirm_pass_hint}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961"
                      stroke="#26313D"
                      strokeWidth="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z"
                      stroke="#26313D"
                      strokeWidth="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5975 10.7999H12.6035"
                      stroke="#26313D"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.89825 10.7999H9.90431"
                      stroke="#26313D"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.19707 10.7999H7.20314"
                      stroke="#26313D"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className={styles.pass_hint_text}>
                    <div className={styles.strong}>
                      {dublicatedcontent?.password_is_never_sent_to_ostreon_servers}
                    </div>
                    {dublicatedcontent?.to_learn_mor_abour_security_please_read}{" "}
                    {parse(dublicatedcontent?.zero_trust_zero_knowledge_policy)}
                    <div className={styles.red_text}>
                      {dublicatedcontent?.save_it_in_a_safe_place}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.footer_upper}>
            <div
              onClick={(e) => {
                setChecked(!checked);
              }}
              className={`${styles.checkbox} ${
                checked ? styles.checked : styles.not_checked
              }`}
            />
            <div className={styles.tos}>
              {dublicatedcontent?.by_checking_this_box_you_agree}{" "}
              <a
                href="/terms-and-conditions"
                target="_blank"
                className={styles.bluetext}
              >
                {dublicatedcontent?.terms_of_service}
              </a>
              ,{" "}
              <a
                href="/privacy-policy"
                target="_blank"
                className={styles.bluetext}
              >
                {dublicatedcontent?.privacy_policy}
              </a>
            </div>
          </div>

          <div className={styles.buttons_div}>
            <button
              disabled={!checked}
              onClick={(e) => {
                e.preventDefault();
                handleClick();
              }}
              className={styles.bluebutton}
            >
              {dublicatedcontent?.create_your_partner_account}
            </button>
          </div>
        </div>
        {error.register_error ? (
          <div type="password" className={styles.error_div}>
            <div className={styles.error_logo}></div>
            <div>{error.register_error}</div>
          </div>
        ) : null}
      </div>
    </div>
    :null}</>
  );
}
const generateKey = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let uid = "";
  for (let i = 0; i < 32; i++) {
    uid += chars[Math.floor(Math.random() * chars.length)];
  }
  return uid.replace(/(.{4})/g, "$1-").slice(0, -1);
};
export { PartnerLogin, generateKey };
